export const REQUISICAO_FIND_ONE = 'REQUISICAO_FIND_ONE';
export const REQUISICAO_FIND_ONE_SUCCESS = 'REQUISICAO_FIND_ONE_SUCCESS';
export const REQUISICAO_CLEAR_SELECTED = 'REQUISICAO_CLEAR_SELECTED';
export const REQUISICAO_FETCH_CATALOGO = 'REQUISICAO_FETCH_CATALOGO';
export const REQUISICAO_FETCH_CATALOGO_SUCCESS = 'REQUISICAO_FETCH_CATALOGO_SUCCESS';
export const REQUISICAO_CREATE = 'REQUISICAO_CREATE';
export const REQUISICAO_UPDATE = 'REQUISICAO_UPDATE';
export const REQUISICAO_DELETE = 'REQUISICAO_DELETE';
export const REQUISICAO_APROVAR_PARCIAL = 'REQUISICAO_APROVAR_PARCIAL';
export const REQUISICAO_CANCELAR = 'REQUISICAO_CANCELAR';
export const REQUISICAO_CRIAR_ENTREGAS = 'REQUISICAO_CRIAR_ENTREGAS';
export const REQUISICAO_ATUALIZAR_ENTREGA = 'REQUISICAO_ATUALIZAR_ENTREGA';
export const REQUISICAO_CANCELAR_ENTREGA = 'REQUISICAO_CANCELAR_ENTREGA';
export const REQUISICAO_DESPACHAR_ENTREGA = 'REQUISICAO_DESPACHAR_ENTREGA';
export const REQUISICAO_FINALIZAR_ENTREGA = 'REQUISICAO_FINALIZAR_ENTREGA';
export const REQUISICAO_RASTREAMENTO = 'REQUISICAO_RASTREAMENTO';
export const REQUISICAO_PEDIDO_RECEBER = 'REQUISICAO_PEDIDO_RECEBER';
export const REQUISICAO_PEDIDO_CANCELAR = 'REQUISICAO_PEDIDO_CANCELAR';
export const REQUISICAO_FETCH_DISPONIBILIDADE = 'REQUISICAO_FETCH_DISPONIBILIDADE';
export const REQUISICAO_FETCH_DISPONIBILIDADE_SUCCESS = 'REQUISICAO_FETCH_DISPONIBILIDADE_SUCCESS';
export const REQUISICAO_FETCH_DISPONIBILIDADE_ERROR = 'REQUISICAO_FETCH_DISPONIBILIDADE_ERROR';
export const REQUISICAO_CLEAR_DISPONIBILIDADE = 'REQUISICAO_CLEAR_DISPONIBILIDADE';
